export const NAV_LINKS = [
 { href: '#services', label: 'Services' },
 { href: '#how-we-work', label: 'Approach' },
 { href: '#who-we-serve', label: 'Who we serve' },
 { href: '#about', label: 'About' },
 { href: '#faq', label: 'FAQ' }
];

export const TICKER = [
 'Healthcare',
 'Nonprofit',
 'Manufacturing',
 'Multi-site operations',
 'Compliance-aware',
 '20-500 employees'
];

export const STATS = [
 { value: '20+', label: 'years of technology leadership behind every recommendation' },
 { value: '3', label: 'core sectors: healthcare, nonprofit & manufacturing' },
 { value: '12-18', label: 'month roadmap horizon, refreshed quarterly' },
 { value: '0', label: 'system access needed to start' }
];

export const EBS_OWNS = [
 'Strategy & business priorities',
 'Requirements & provider comparison',
 'Renewals, contracts & governance',
 'Risk prioritization & roadmap'
];

export const PROVIDERS_OWN = [
 'Engineering & implementation',
 'Day-to-day support & monitoring',
 'Penetration & compliance testing',
 'Hardware, licensing & fulfillment'
];

export const SECTORS = [
 {
 title: 'Nonprofit',
 tone: 'amber',
 motif: 'petals',
 body: 'Reduce technology complexity, strengthen cybersecurity, optimize vendor spending, and build a practical roadmap aligned to mission and budget.',
 tags: ['Board reporting', 'Grant-aligned budgets']
 },
 {
 title: 'Healthcare',
 tone: 'cyan',
 motif: 'cross',
 body: 'Convert cybersecurity, infrastructure, cloud, vendor, and resilience needs into an actionable roadmap - and source the specialists to execute it.',
 tags: ['EHR hosting', 'Continuity & DR']
 },
 {
 title: 'Manufacturing',
 tone: 'sky',
 motif: 'stack',
 body: 'Align plant, warehouse, and office technology around uptime, cybersecurity, and vendor accountability - without forcing every decision through one MSP.',
 tags: ['Multi-site networks', 'OT / IT uptime']
 }
];

export const STEPS = [
 {
 title: 'Discover priorities',
 body: 'We clarify business goals, current IT model, renewals, and risk - before recommending tools or providers.',
 outcomes: ['Shared view of goals & constraints', 'Renewal & risk pressure points']
 },
 {
 title: 'Shape the roadmap',
 body: 'EBS translates goals into requirements, priorities, and investment options you can govern.',
 outcomes: ['Executive-ready priorities', 'Clear decision criteria for spend']
 },
 {
 title: 'Shortlist providers',
 body: 'We compare qualified providers on fit, risk, service, and cost - and support the decision.',
 outcomes: ['Structured provider comparison', 'A recommendation you can defend']
 },
 {
 title: 'Govern delivery',
 body: 'Providers implement and support. EBS stays in for governance, QBRs, renewals, and escalation.',
 outcomes: ['Ongoing vendor oversight', 'Renewals aligned to roadmap']
 }
];

// `chip` is the short label shown in the contact form's "From your fit check" row.
export const FIT_SIGNALS = [
 { text: 'An MSP, telecom, cloud, or Microsoft renewal is coming up', chip: 'Renewal coming up' },
 { text: 'You have technology complexity but no dedicated CIO / CTO', chip: 'No dedicated CIO / CTO' },
 { text: 'Multi-site growth is straining IT, security, or communications', chip: 'Multi-site growth' },
 { text: 'The board is asking about cybersecurity or continuity risk', chip: 'Board asking about risk' },
 { text: 'Vendor spend is high, but accountability is thin', chip: 'Thin vendor accountability' },
 { text: 'You need a practical 12-18 month roadmap - not another tool pitch', chip: 'Need a 12-18 mo roadmap' }
];

export const FAQS = [
 {
 q: 'Are you an MSP?',
 a: 'No. EBS is a technology advisory and sourcing firm. We own strategy, requirements, provider comparison, and governance. Qualified providers own engineering, implementation, and support.'
 },
 {
 q: 'Who does the technical work?',
 a: 'Selected providers deliver architecture, migration, managed services, and support under their own agreements. EBS remains involved for decision support, QBRs, renewals, and escalation when business expectations are not being met.'
 },
 {
 q: 'Do you get paid by technology providers?',
 a: 'EBS evaluates options based on client requirements and works across a broad provider ecosystem. EBS may receive compensation from technology providers or distribution partners when clients purchase certain solutions.'
 },
 {
 q: 'Do you work with PHI and other sensitive data?',
 a: 'Yes. We work with healthcare and other organizations that handle PHI and sensitive data, and we treat it with appropriate safeguards. A Technology Strategy Review doesn’t require system access. EBS does not guarantee HIPAA compliance; formal assessments, testing, and implementation are handled by appropriately scoped, qualified resources.'
 },
 {
 q: 'What is the best first step?',
 a: 'Schedule a Technology Strategy Review. In 30-45 minutes we clarify priorities, surface high-level risks and opportunities, and recommend whether the next step is no action, a paid assessment, vCIO advisory, provider sourcing, or a combination.'
 },
 {
 q: 'Who typically engages EBS?',
 a: 'CEOs, CFOs, COOs, IT leaders, and compliance stakeholders at nonprofit, healthcare, and manufacturing organizations - often with roughly 20-500 employees, meaningful technology spend, and limited CIO/CTO bandwidth.'
 }
];

export const NEXT_STEPS = [
 {
 title: 'We reply within one business day',
 detail: 'An advisor, not a sales rep, confirms a time that works.'
 },
 {
 title: 'A 30-45 minute conversation',
 detail: 'Priorities, renewals, risk, and your current providers.'
 },
 {
 title: 'A short recap with a recommended next step',
 detail: 'In writing, with no obligation to continue.'
 }
];
